import { useEffect, useState } from 'react';
import { useParams, Routes, Route, Outlet } from 'react-router-dom';
import css from './StaffDetails.module.css';
import toShort from '../../../../../services/utils/dateParser';

import * as staffServices from '../../../../../services/staffServices';
import ModalForm from '../../../_common/ModalForm';
import SDGeneral from './SDGeneral';
import AddNewStaff from '../overview/AddNewStaff';
import StaffCompetence from './StaffCompetence';
import Tabs from '../../../../00_app/Tabs';
import StaffExperience from '../experience/StaffExperience';

function StaffDetails() {
    const { staffId } = useParams();
    const [staffDetails, setStaffDetails] = useState([{ staffId: staffId }]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        staffServices
            .getById(staffId)
            .then((result) => {
                setStaffDetails((state) => result.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [staffId, showModal]);

    //Open and close the input form
    const toggleModal = () => setShowModal(!showModal);

    // const onAdd = (data) => {
    //     return true;
    // };

    return (
        <div>
            <h1 className={css.h1}>{`(${staffDetails[0].staffNo}) ${staffDetails[0].staffName}`}</h1>
            <SDGeneral staff={staffDetails[0]} toggleModal={toggleModal} />

            <Tabs
                tabs={[
                    { to: `/staff/details/${staffId}/staff_competence`, title: 'Competence' },
                    { to: `/staff/details/${staffId}/staff_experience`, title: 'Experience' },
                    // { to: `/staff/details/${staffDetails[0].staffId}/exam`, title: 'Exams' },
                    // { to: `/staff/details/${staffDetails[0].staffId}/schedule`, title: 'Schedule' },
                ]}
            />
            <Routes>
                <Route path="staff_competence" element={<StaffCompetence id={staffId} />} />
                <Route path="staff_experience" element={<StaffExperience id={staffId}/>} />
            </Routes>
            {/* <Outlet /> */}

            {/* <StaffCompetence id={staffDetails[0].staffId}/> */}
            {/* <StaffExperience /> */}

            <ModalForm showModal={showModal}>
                <AddNewStaff staffData={staffDetails[0]} toggleModal={toggleModal} func={'edit'} />
            </ModalForm>
        </div>
    );
}

export default StaffDetails;
